import { Link } from "react-router-dom";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { NAV_LINKS } from "@/constants/site";
import { ChevronRight } from "lucide-react";

export const MobileNavSheet = ({ open, onOpenChange, onNavigate }) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent
      side="right"
      data-testid="mobile-nav-sheet"
      className="w-[88vw] max-w-sm border-l p-0"
      style={{ background: "var(--gm-navy-950)", borderColor: "rgba(255,255,255,0.12)" }}
    >
      <SheetHeader className="px-5 pt-5 text-left">
        <SheetTitle className="font-display text-white">Menu</SheetTitle>
      </SheetHeader>
      <div className="flex flex-col gap-1 p-4">
        {NAV_LINKS.map((link) => (
          <button
            key={link.id}
            type="button"
            onClick={() => onNavigate(link.id)}
            data-testid={`mobile-nav-link-${link.id}`}
            className="flex min-h-[48px] items-center justify-between rounded-xl px-4 text-left text-sm font-medium text-white hover:bg-white/5"
          >
            {link.label}
            <ChevronRight className="h-4 w-4" style={{ color: "var(--gm-muted-2)" }} />
          </button>
        ))}
        <div className="my-3 h-px" style={{ background: "rgba(255,255,255,0.1)" }} />
        <Link
          to="/free-access"
          onClick={() => onOpenChange(false)}
          data-testid="mobile-nav-free-access"
          className="gm-btn-ghost flex min-h-[48px] items-center justify-center rounded-xl text-sm font-semibold"
        >
          Apply for free access
        </Link>
        <button
          type="button"
          onClick={() => onNavigate("pricing")}
          data-testid="mobile-nav-primary-cta"
          className="gm-btn-red mt-2 flex min-h-[48px] items-center justify-center rounded-xl text-sm font-bold"
        >
          Get Goldmap EA
        </button>
      </div>
    </SheetContent>
  </Sheet>
);
